import React from "react";
import { Document, Page } from "react-pdf";
import { Account } from "../utils/AccountStore";
import { Attachment, IsRenderable, Questionnaire } from "../utils/ServiceManagerAPI";
import SkeletonWrapper from "./SkeltonWrapper";
import StyledModal from "./StyledModel";

import { FcFile } from "react-icons/fc";
import { HiTrash } from "react-icons/hi";
import { msalInstance } from "../index";
import { getTokenPopup } from "../utils/HttpClient";
import ConfirmButton from "./ConfirmButton";
import ScrollContainer from "./ScrollContainer";

import * as styled from "styled-components";
import "../main.css";

export const PDFDocumentWrapper = styled.default.div`
  canvas {
    width: 100% !important;
    height: auto !important;
  }
`;

const RenderAttachments = ({ questionnaire, attachments, user, deleteAttachment }: { questionnaire?: Questionnaire; attachments: Attachment[]; user: Account; deleteAttachment?: Function }) => {
    const [showAttachment, setShowAttachment] = React.useState(false);
    const [selectedAttachment, setSelectedAttachment] = React.useState<Attachment>();

    const [token, setToken] = React.useState<string>();

    React.useEffect(() => {
        const account = msalInstance.getActiveAccount();
        if (account) {
            getTokenPopup(account).then((token) => {
                setToken(token.accessToken);
            });
        }
    }, []);

    const select = (attachment: Attachment) => {
        setSelectedAttachment(attachment);
        setShowAttachment(true);
        if (IsRenderable(attachment.contentType)) {
            setLoading(true);
        }
    };

    const [loading, setLoading] = React.useState(false);

    const toggleAttachmentModal = () => {
        if (showAttachment) {
            setSelectedAttachment(undefined);
        }
        setShowAttachment(!showAttachment);
    };

    const [pages, setPages] = React.useState(0);

    const doDelete = () => {
        if (selectedAttachment) {
            deleteAttachment && deleteAttachment(selectedAttachment.questionID, selectedAttachment.id);
        }
        toggleAttachmentModal();
    };

    return (
        <>
            {(user.hasQuestionnaireAccess(questionnaire?.id, 8) || user.hasCampaignAccess(questionnaire?.campaignID, 16)) && (
                <div className="flex flex-col gap-2">
                    {attachments?.map((attachment, attachmentKey) => (
                        <div className="flex flex-row" key={attachment.id}>
                            <div className="flex items-center gap-2">
                                <button
                                    className="flex items-center gap-2 text-brand hover:text-brand-dark transition-colors"
                                    onClick={() => select(attachment)}
                                >
                                    <FcFile size="18px" />
                                    <span className="underline">{attachment.name}</span>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <StyledModal isOpen={showAttachment} setIsOpen={() => toggleAttachmentModal()}>
                {selectedAttachment && (
                    <div className="w-full max-w-4xl flex flex-col gap-2 p-2">
                        <a 
                            href={`/api/Attachments/${selectedAttachment.id}`}
                            className="text-brand hover:text-brand-dark underline"
                        >
                            Download {selectedAttachment.name}
                        </a>
                        {!questionnaire?.locked && deleteAttachment && user.hasQuestionnaireAccess(questionnaire?.id, 8) && selectedAttachment.userID == user.id && (
                            <ConfirmButton label="Delete Attachment" color="status-critical" icon={<HiTrash size="18px" />} onClick={() => doDelete()}></ConfirmButton>
                        )}
                        {IsRenderable(selectedAttachment.contentType) && (
                            <div className="p-2">
                                <ScrollContainer direction="-x">
                                    {selectedAttachment.contentType == "application/pdf" && (
                                        <PDFDocumentWrapper>
                                            <Document
                                                file={`${ServiceManagerUrl}api/Attachments/${selectedAttachment.id}`}
                                                onLoadSuccess={({ numPages }: { numPages: number }) => {
                                                    setPages(numPages);
                                                    setLoading(false);
                                                }}
                                                options={{
                                                    httpHeaders: {
                                                        Authorization: `IdentityBearer ${token}`,
                                                    },
                                                }}
                                            >
                                                {Array.from(new Array(pages), (el, index) => (
                                                    <Page pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} width={750} />
                                                ))}
                                            </Document>
                                        </PDFDocumentWrapper>
                                    )}
                                    {selectedAttachment.contentType != "application/pdf" && (
                                        <object
                                            onLoad={() => setLoading(false)}
                                            data={`${ServiceManagerUrl}api/Attachments/${selectedAttachment.id}`}
                                            type={selectedAttachment.contentType}
                                            width="100%"
                                            height="100%"
                                        ></object>
                                    )}
                                    <SkeletonWrapper loading={loading}>
                                        <></>
                                    </SkeletonWrapper>
                                </ScrollContainer>
                            </div>
                        )}
                        <div className="flex flex-row justify-end items-center gap-2 mt-2">
                            <button 
                                className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                                onClick={() => toggleAttachmentModal()}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}
            </StyledModal>
        </>
    );
};

export default RenderAttachments;
